import {
  useMutation,
  useQueryClient,
} from 'react-query'
import httpClient from './httpClient'

const Post = ( endpoint, params ) => {
  const queryClient = useQueryClient()

  const postQueryFunction = ( params ) => new Promise( ( resolve, reject ) => {
    httpClient.post(
      `${ endpoint }/`,
      { ...params },
    )
      .then( ( { data } ) => {
        resolve( data )
      } )
      .catch( ( e ) => {
        reject( e )
      } )
  } )

  return useMutation( postQueryFunction, {
    // Refetch data after mutation
    onSettled: () => {
      queryClient.invalidateQueries( endpoint )
    },
  } )
}

export default Post